module.exports = __webpack_public_path__ + "img/logo-gtr.52792978.svg";